import AuthorBiography from 'models/AuthorBiography';
import * as authUtility from "../lib/AuthorUtility";

export function getAuthorBiography(store) {
    const bookContents = store.FeatureContent.BookContents;
    let retval;

    if(bookContents) {
        const bioData = bookContents.biographies;
        const index = 0;
        if(bioData && bioData.length > 0) {
            let biography = bioData[index];
            //Biography exists so try and get the author name
            biography.AuthorName = getBookAuthor(store);
            retval = new AuthorBiography(biography);
        }
    }
     return retval;
}

/**
 * Retrieves the author for the current book.
 * @param {*} data Content by Query data as a JS object
 */
function getBookAuthor(data){
    let retval;
    if(data.TitleInfo && data.TitleInfo.author) {
        retval = authUtility.formatAuthorName(data.TitleInfo.author);
    }   
    return retval;
}


// WEBPACK FOOTER //
// ./src/data/AuthorBiographySelector.js